import React from "react";

const PrivacyPolicies = () => (
    <>
        <style>{`
            .pp-section { border-bottom: 1px solid #e0e0e0; }
            .pp-section > summary {
                cursor: pointer;
                font-size: 1.3em;
                font-weight: bold;
                padding: 12px 4px;
                list-style: none;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
            }
            .pp-section > summary::-webkit-details-marker { display: none; }
            .pp-section > summary::after {
                content: "▶";
                font-size: 0.75em;
                color: #555;
                transition: transform 0.2s ease;
                flex-shrink: 0;
            }
            .pp-section[open] > summary::after { transform: rotate(90deg); }
            .pp-section > *:not(summary) { margin-left: 4px; }
        `}</style>
        <h2>SJライフアプリプライバシーポリシー</h2>

        <p>株式会社オークローンマーケティング（以下「当社」といいます。 ）及びその日本国内の関係会社（以下「当社グループ」といいます。 ）は、当社が提供するアプリケーション「SJライフアプリ」（以下「本アプリ」といいます。 ）および本アプリに関するサービス（以下「本サービス」といいます。 ）において、個人情報の取り扱いに関してその重要性を認識し、その保護の徹底を図り、本サービスの利用者（以下「ユーザー」といいます。 ）の信頼を得るために、個人情報の保護に関する法律や行政機関・業界団体等の定める指針等を遵守するとともに、以下のプライバシーポリシーに従うことをここに宣言します。</p>

        <details className="pp-section">
            <summary>1. 個人情報</summary>
        <p>「個人情報」とは、個人に関する情報であり、一切のユーザーに関する情報であって、住所、氏名、生年月日、電話番号等の文字、映像、音声などによって当該個人を識別できる情報をいいます（その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的に個人を識別できるものも個人情報に含まれます。 ） 。</p>
        <p>また、「要配慮個人情報」とは、個人情報のうち、本人の人種、信条、社会的身分、病歴、犯罪の経歴、犯罪により害を被った事実を含み、個人情報保護法第2条第3項に定義される情報をいいます。</p>

        </details>

        <details className="pp-section">
            <summary>2. 個人情報の取得</summary>
        <p>（１）当社グループは、ユーザーに個人情報の利用目的をお知らせし、必要な場合は同意を得てユーザーより個人情報を取得します。取得は、できる限りその目的を限定して行い、取得する個人情報の範囲は、取得の目的を達成するために必要な限度に限るものとします。また、取得は適法かつ公正な手段により行います。ただし、ご同意いただけない場合は、当社グループが提供するサービス等を利用できない場合もありますのでご了承ください。</p>

        <p>（２）取得する方法</p>
        <p>当社は、個人情報を以下の方法により取得します。</p>
        <p>① ユーザーご自身から、本サービスの利用・閲覧時等に直接提供いただく方法</p>
        <p>② ユーザーの同意のもと外部連携サービスから取得する方法</p>
        <p>③ 提携医療機関（当社が本サービスの提供のために提携する医療機関。以下同じ。 ）から取得する方法。なお、ユーザーは、自らが本アプリを通じて提携医療機関に対し診療等の予約をした場合は、当該提携医療機関が取得したユーザーの個人情報（診療内容、治療・処方内容、既往歴、服薬歴等、本サービスにおいて当該医療機関が診療を提供するに際し取得した個人情報であり、要配慮個人情報を含みます。 ）が、当該提携医療機関から当社に提供されることに同意したものとします。</p>
        <p>④ ユーザーが本サービスに連携させたリング型ウェアラブル機器等の対応機器（以下「連携機器」といいます。 ）から取得する方法</p>

        <p>（３）取得する情報<br />当社が「3.個人情報の利用目的」に定める目的を達成するために取得する個人情報には、次のものが含まれます。なお、当社は、法令で認められている場合を除き、あらかじめユーザー本人の同意（本プライバシーポリシーへの同意により取得する同意を含みます。 ）を得ることなく、要配慮個人情報を取得しません。</p>
        <p>① 氏名、性別、生年月日、住所、電話番号、メールアドレス</p>
        <p>② 利用する医療機関名、診療科、診察日、保険証情報、問診票回答情報その他ユーザーが提供する健康情報</p>
        <p>③ 利用する調剤薬局名、受付日時、処方箋画像（薬剤名、調剤日、剤形、用量、用法を含む。 ）、服薬情報、質問表回答情報その他利用者が提供する健康情報</p>
        <p>④ 医師による医薬品の処方の有無、内容、数量、配送場所、その他医師による診療内容に関する情報</p>
        <p>⑤ 本アプリにアクセスしている端末情報、クレジットカードその他の電子決済に関する必要情報、ユーザーが本サービスと連携させることを選択した他サービスのログインID/Pass等のアカウント情報や他サービスに入力・記録していた健康情報等</p>
        <p>⑥ アレルギー歴、副作用歴、既往歴、体質、併用薬、嗜好品、生活習慣等の情報</p>
        <p>⑦ その他利用者が本サービスの利用に際して入力、提供する情報</p>
        <p>⑧ ユーザーが本サービスと連携させた連携機器（リング型ウェアラブル機器等）から取得する心拍数、血中酸素、体温、睡眠、活動量等の生体情報その他の測定データ</p>

        <p>（４）保護者又は本人の同意<br />未成年のユーザーが本サービスを利用する場合、必ず保護者の方に本サービスの利用規約及び本ポリシーを確認してもらい、保護者の方の同意を取得した上で個人情報を入力するようにしてください。また、ユーザーが本サービスにおいて他の方の個人情報を入力する場合、必ず本人（本人が未成年者である場合にはその法定代理人の方）に本サービスの利用規約及び本ポリシーを確認してもらい、その同意を取得した上で個人情報を入力するようにしてください。</p>

        </details>

        <details className="pp-section">
            <summary>3. 個人情報の利用目的</summary>
        <p>当社グループは、ユーザーの個人情報を以下の目的で利用いたします。</p>
        <p>① ユーザーに本サービスを提供するため</p>
        <p>② ユーザーに本サービスにおいて提携医療機関による医療行為（本アプリ上での問診フォームを使用した問診、処方された薬の配送を含む。 ）を提供するため</p>
        <p>③ ユーザーの予約・受診・配送の完了状況等の確認をし、必要なリマインダ等の連絡をするため</p>
        <p>④ ユーザーに健康や疾患に関する一般的な情報を提供するため</p>
        <p>⑤ ユーザーに提携医療機関に関する情報を提供するため</p>
        <p>⑥ ユーザーが本サービス上で自己に関する情報を閲覧できるようにするため</p>
        <p>⑦ ユーザーの属性情報や、診療内容、治療・処方内容、既往歴、服薬歴等に基づくプロモーション情報を配信するため（個人を特定できない範囲での利用者の性別等の把握、本サービス内および当社グループが契約するサービス内での行動・アクセス履歴の把握）</p>
        <p>⑧ 通信販売業務の遂行のため</p>
        <p>⑨ ご購入商品に関するアフターサービスの実施のため</p>
        <p>⑩ 新商品やサービス、キャンペーン情報のご案内のため</p>
        <p>⑪ アンケートの実施、およびアンケート結果の分析のため</p>
        <p>⑫ モニターの募集、およびモニター情報の利用のため</p>
        <p>⑬ 映像等広告物への出演依頼、および出演後の広告物の利用のため</p>
        <p>⑭ 当社グループ内での統計データの作成、顧客分析のため</p>
        <p>⑮ 当社グループ及び第三者の商品等（保険その他の金融商品を含む）の販売、販売の勧誘、発送、サービス提供の遂行のため</p>
        <p>⑯ ユーザーの本人確認のため</p>
        <p>⑰ 本アプリ及び本サービスに関する利用者からのお問合せ、ご相談および苦情への対応ならびに紛争の解決のために必要な業務を行うため</p>
        <p>⑱ 本アプリ及び本サービスの改善、不具合対応、および開発を行うため</p>
        <p>⑲ 本アプリ及び本サービスの利用規約に違反した利用者による本アプリ及び本サービスの利用を停止等するため</p>
        <p>⑳ 本プライバシーポリシー記載の方法により第三者提供を行うため</p>
        <p>㉑ ユーザーが本サービスに連携させた連携機器（リング型ウェアラブル機器等）から取得した心拍数等の測定データを、本サービス上でユーザーの健康情報として表示するため</p>
        <p>㉒ その他上記目的に関連・付随する目的の達成に必要な場合</p>

        </details>

        <details className="pp-section">
            <summary>4. 個人情報の利用</summary>
        <p>当社グループは、ユーザーの個人情報を、前項およびあらかじめお知らせした利用目的の範囲内で利用し、ユーザーの同意なくその他の目的には利用いたしません。</p>
        <p>また、当社グループは、違法又は不当な行為を助長し、又は誘発する恐れがある方法によりユーザーの個人情報を利用することはありません。</p>
        <p>【行動ターゲティング広告について】</p>
        <p>当社グループはインターネット上で取得したユーザーの個人情報を用いて、インターネット広告会社が提供する行動ターゲティング広告を利用する場合があります。</p>
        <p>行動ターゲティング広告に関する詳細は<a href="https://www.shopjapan.co.jp/legal/targeting/" target="_blank" rel="noopener noreferrer">「行動ターゲティングに関するポリシー」</a>をご参照ください。</p>

        </details>

        <details className="pp-section">
            <summary>5. 個人情報の共同利用</summary>
        <p>当社グループは以下の通り共同利用を行います。</p>

        <table>
            <tbody>
                <tr>
                    <td>共同して利用する者の範囲</td>
                    <td>当社グループ及び株式会社NTTドコモ</td>
                </tr>
                <tr>
                    <td>共同して利用される個人情報の項目</td>
                    <td>・氏名<br />・郵便番号<br />・住所<br />・電話番号<br />・性別<br />・生年月日<br />・購買履歴<br />・購入された商品または利用されたサービスに関する情報<br />・当社グループのウェブサイトの閲覧履歴</td>
                </tr>
                <tr>
                    <td>共同して利用する者の利用目的</td>
                    <td>上記「3.個人情報の利用目的」の<br />⑭当社グループ内での統計データの作成、顧客分析<br />⑮当社グループ及び第三者の商品等（保険その他の金融商品を含む）の販売、販売の勧誘、発送、サービス提供の遂行</td>
                </tr>
                <tr>
                    <td>共同して利用する個人情報の管理について<br />責任を有する者の名称及び住所、並びに代<br />表者氏名</td>
                    <td>名称：株式会社オークローンマーケティング<br />住所：愛知県名古屋市東区東桜1丁目13番3号<br />代表者氏名：ロバート・W・ローチ</td>
                </tr>
                <tr>
                    <td>個人情報の取得方法</td>
                    <td>電話による取得、WEBサイトや申込み用紙等の書面による取得</td>
                </tr>
            </tbody>
        </table>

        <table>
            <tbody>
                <tr>
                    <td>共同して利用する者の範囲</td>
                    <td>当社グループ及びアフィニティデジタル保険サービシーズ合同会社</td>
                </tr>
                <tr>
                    <td>共同して利用される個人情報の項目</td>
                    <td>・氏名<br />・郵便番号<br />・住所<br />・電話番号<br />・性別<br />・生年月日<br />・購買履歴<br />・購入された商品または利用されたサービスに関する情報</td>
                </tr>
                <tr>
                    <td>共同して利用する者の利用目的</td>
                    <td>上記「3.個人情報の利用目的」の<br />⑮当社グループ及び第三者の商品等（保険その他の金融商品を含む）の販売、販売の勧誘、発送、サービス提供の遂行</td>
                </tr>
                <tr>
                    <td>共同して利用する個人情報の管理について<br />責任を有する者の名称及び住所、並びに代<br />表者氏名</td>
                    <td>名称：株式会社オークローンマーケティング<br />住所：愛知県名古屋市東区東桜1丁目13番3号<br />代表者氏名：ロバート・W・ローチ</td>
                </tr>
                <tr>
                    <td>個人情報の取得方法</td>
                    <td>電話による取得、WEBサイトや申込み用紙等の書面による取得</td>
                </tr>
            </tbody>
        </table>

        </details>

        <details className="pp-section">
            <summary>6. 個人情報の第三者への提供等</summary>
        <p>（１）当社グループは、ユーザーの個人情報を、本人の事前の同意なく法律上秘密保持義務を負う者または機密保持に関する契約を締結した業務委託先以外の第三者に提供することはありません。なお、ユーザーは、当社が、本プライバシーポリシーの「2.個人情報の取得」に基づきユーザーから取得するユーザーの個人情報を、当社の提携先企業（製薬事業等を営む企業）に対し書面（電磁的記録を含む）その他の方法により、マーケティング・事業開発・研究開発等のために共有されることについて同意するものとします。また、個人情報の取扱を外部（外国にある事業者含む）に委託する場合、業務委託契約等において個人情報の取扱に関する機密保持条項など必要な事項を取り決め、適切な管理を実施いたします。</p>

        <p>（２）前項の定めにかかわらず、当社は以下の場合には、ユーザーの同意なく個人情報を提供します。</p>
        <p>① 法令に基づく場合</p>
        <p>② 人の生命、身体又は財産の保護のために必要がある場合であって、ユーザーの同意を得ることが困難である場合</p>
        <p>③ 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ユーザーの同意を得ることが困難である場合</p>
        <p>④ 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることによってその事務の遂行に支障を及ぼすおそれがあると当社が判断した場合</p>
        <p>⑤ 裁判所、検察庁、警察、弁護士会、消費者センターまたはこれらに準じる機関から、個人情報についての開示を求められた場合</p>
        <p>⑥ ユーザーから明示的に第三者への開示または提供を求められた場合</p>
        <p>⑦ 利用目的の達成に必要な範囲内において個人情報取扱い業務の一部または全部を委託する場合</p>
        <p>⑧ 合併その他の事由による事業の承継に伴って提供される場合</p>
        <p>⑨ ユーザーが入力したクレジットカード情報等の決済に必要な情報を、ユーザーの本サービス利用に伴う対価を決済するために必要な限度で外部決済業者に対して提供する場合</p>

        <p>（３）ユーザーは、本アプリを通じて提携医療機関に対し診療等の予約をした場合は、自己の個人情報が当該提携医療機関に提供されること及び当該医療機関が独自にユーザーの個人情報を取得すること、並びにそれらの個人情報が当該医療機関における医業その他の業務の提供の目的及び当該医療機関が別途公表する個人情報の利用目的のために利用することについて同意したものとします。</p>

        <p>（４）当社は、ユーザーの個人情報を外国にある第三者へ提供する場合があります。外国にある第三者への提供に関する情報は、以下のとおりです。</p>
        <p>
            ■提供先の第三者が所在する外国の名称<br />
            UK<br />
            US<br />
            Singapore<br />
            Australia<br />
            Canada<br />
            European Union<br />
            Italy<br />
            France<br />
            Spain<br />
            Germany<br />
            Portugal<br />
            Denmark<br />
            Finland<br />
            Norway<br />
            Poland<br />
            Sweden<br />
            Russia<br />
            Turkey<br />
            Brazil<br />
            Mexico<br />
            Hong Kong<br />
            South Korea<br />
            India<br />
            Indonesia<br />
            Philippines<br />
            Thailand<br />
            Malaysia<br />
            China<br />
            UAE
        </p>
        <p>■当該外国における個人情報の保護に関する制度に関する情報</p>
        <p>提供先の第三者が所在する外国における個人情報の保護に関する制度に関する情報については、以下の個人情報保護委員会のウェブサイトをご参照ください。<br /><a href="https://www.ppc.go.jp/enforcement/infoprovision/laws/" target="_blank" rel="noopener noreferrer">https://www.ppc.go.jp/enforcement/infoprovision/laws/</a></p>
        <p>■当該第三者が講ずる個人情報の保護のための措置に関する情報</p>
        <p>提供先は、概ね個人情報の取扱いについて我が国の個人情報取扱事業者に求められる措置と同水準の措置を講じているものの、取得した個人情報についての利用目的の通知・公表を行っていない場合があります。</p>

        </details>

        <details className="pp-section">
            <summary>7. 社内体制の整備</summary>
        <p>当社グループは、プライバシーポリシーに基づき、個人情報の保護に関する社内規程を整備し、個人情報の取扱いについて明確な方針を示し、当社グループの役職員に対し周知・教育し、個人情報保護体制を構築・維持・改善し、個人情報の保護に関する内部監査体制を整備します。</p>
        <p>また、当社グループは、個人情報の漏えい、滅失、または毀損の防止に努めます。ユーザーおよびの個人情報の取り扱いについて不備を発見した際は、速やかに是正を実施し、継続的に改善をしてまいります。</p>

        </details>

        <details className="pp-section">
            <summary>8. 個人情報の開示・訂正等</summary>
        <p>当社グループがお預かりしているご本人の個人情報について、開示、訂正、利用停止、削除などを希望される場合または苦情および相談等をお申し出になる場合は、下記個人情報に関するお問合せ窓口までお問合せください。</p>
        <p>個人情報に関するお問合せ窓口<br />カスタマーサービスセンター<br />電話：0120-380-096</p>
        <p>個人情報の開示をお申し出いただいたときは、当社グループの業務の遂行に著しい支障をきたす場合、または個人の生命、身体、財産その他の利益を害するおそれのある場合を除き、遅滞なくこれをユーザーに開示します。</p>
        <p>個人情報の訂正、利用停止、削除をお申し出いただいたときは、遅滞なく調査を行い、訂正、利用停止、削除を必要とする事由があるときは、これを行います。ただし、利用停止、削除の場合、お買い上げいただいた商品の返品・修理・交換等のサービスを継続的にお届けできなくなる可能性があることをご了承ください。</p>
        <p>個人情報の漏洩や、第三者による改ざん、削除などを防ぐため、個人情報の開示・訂正等に際しては、ご本人であることを確認させていただきます。</p>

        </details>

        <details className="pp-section">
            <summary>9. インターネットストアのセキュリティ</summary>
        <p>当社グループのインターネットストアでユーザーにご入力いただいた情報は暗号化技術であるSSL(Secure Socket Layer) により当社グループまで安全に送信されます。</p>
        <p>当社グループは標準的なウェブサーバーログシステムを利用し、アクセス元のIPアドレス、クッキー等のログファイルを取得しています。当社グループは必要に応じ、セキュリティ環境を維持するためにこれらのログファイルを利用することがあります。</p>

        </details>

        <details className="pp-section">
            <summary>10. 電話のボイスレコーディング</summary>
        <p>当社グループは、コールセンターおよびカスタマーサービスセンターを通じて行われた電話注文やお問合せのボイスレコーディングを行う機能を備えています。</p>
        <p>契約内容の確認、ご注文データの入力が正確に行われているか、電話対応に問題がないか等を検証する為に、これらのボイスデータを利用することがあります。</p>

        </details>

        <details className="pp-section">
            <summary>11. 取引先情報</summary>
        <p>当社グループは、受注代行業務を遂行する目的として受託先の顧客の個人情報を取得し一定の期間保管します。</p>

        </details>

        <details className="pp-section">
            <summary>12. 個人情報（社内適用限定）</summary>
        <p>当社グループは、契約管理の為、当社グループの個人情報を取得し保管します。</p>
        <p>当社グループは、業務上必要な場合を除き、第三者に対してこれらの情報をユーザーの同意なしに第三者に提供することはありません。</p>

        </details>

        <details className="pp-section">
            <summary>13. 個人情報保護マネジメントシステム</summary>
        <p>当社グループは、ユーザーの個人情報の取扱いについて、事業内容や社会的環境の変化に適切に対応するため、個人情報保護マネジメントシステムを導入し、継続的に改善してまいります。</p>

        </details>

        <details className="pp-section">
            <summary>14. 保有個人データの安全管理のために講じた措置</summary>
        <p>個人情報保護のために弊社が実施している安全管理措置につきましては<a href="https://www.shopjapan.co.jp/legal/personal_data/" target="_blank" rel="noopener noreferrer">「保有個人データの安全管理のために講じた措置」</a>をご参照ください。</p>

        </details>

        <details className="pp-section">
            <summary>15. 本プライバシーポリシーのお問合せ先</summary>
        <p>本プライバシーポリシーについてのご質問やお問い合わせは、弊社コーポレートサイトのお問合せフォーム（下記）よりお問合せください。</p>
        <a href="https://www.oaklawn.co.jp/contact/confirm.html" target="_blank" rel="noopener noreferrer">https://www.oaklawn.co.jp/contact/confirm.html</a>

        </details>

        <details className="pp-section">
            <summary>16. その他</summary>
        <p>準拠される法律は日本国内の法律とします。</p>

        </details>

        <details className="pp-section">
            <summary>17. 個人情報取扱事業者の名称等（オークローンマーケティンググループ）</summary>
        <p>事業者名称：株式会社オークローンマーケティング<br />本社所在地：愛知県名古屋市東区東桜1丁目13番3号<br />代表者氏名：代表取締役社長　ロバート・W・ローチ</p>
        <p>事業者名称：株式会社インターワールド<br />本社所在地：東京都港区虎ノ門1丁目23番1号<br />代表者氏名：代表取締役社長　青谷 宣孝</p>
        <p>制定日：2025年9月26日<br />改定日：2026年8月10日</p>
        </details>
    </>
);

export default PrivacyPolicies;